webpackJsonp([8],{

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['isSms', 'isTerminal'],
  data: function data() {
    return {
      newPassword: '',
      isValid: false,
      updating: false,
      success: '',
      err: '',
      show: false
    };
  },
  methods: {
    updatePassApi: function updatePassApi() {
      var _this = this;

      this.updating = true;
      var url = 'webshopresource/updatepaymentgatewaypassword';
      var obj = { password: this.newPassword };
      if (this.isSms) url = 'webshopresource/updatesmspassword';
      if (this.isTerminal) {
        url = 'paymentterminal/updatepassword';
        obj = {
          password: this.newPassword,
          companyId: localStorage.selectedTerminal
        };
      }
      this.$http.post(url + '/' + this.$route.params.id, obj).then(function (res) {
        if (res === null) return;
        if (res.body.status === 'Success') {
          _this.success = 'Password updated successfully.';
          _this.updating = false;
          setTimeout(function () {
            _this.success = '';
            _this.$emit('close');
          }, 4000);
          return;
        }
        _this.updating = false;
        _this.err = res.body.statusText;
      }).catch(function (err) {
        _this.updating = false;
        _this.err = err.body.statusText || err.body.message;
      });
    }
  }
});

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.isValid),
      callback: function($$v) {
        _vm.isValid = $$v
      },
      expression: "isValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.password,
      "rules": [function () { return _vm.newPassword.length > 0 || ("" + (_vm.$lang.errors.missingPass)); }],
      "append-icon": _vm.show ? 'visibility' : 'visibility_off',
      "type": _vm.show ? 'text' : 'password'
    },
    on: {
      "click:append": function($event) {
        _vm.show = !_vm.show
      }
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-space-between": "",
      "row": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "disabled": _vm.updating
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.close) + "\n      ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0 primary",
    attrs: {
      "disabled": !_vm.isValid || _vm.updating,
      "loading": _vm.updating
    },
    on: {
      "click": function($event) {
        return _vm.updatePassApi()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.submit) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(584),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/8.3ab7d5bad8b8768ead4a.js